/* eslint-disable max-len */
import { Toasts } from './constants';

export const createToastRequest = (data) => ({ type: Toasts.createToastRequest, data });
export const createToastSuccess = (data) => ({ type: Toasts.createToastSuccess, data });

export const removeToastRequest = (data) => ({ type: Toasts.removeToastRequest, data });
export const removeToastSuccess = (data) => ({ type: Toasts.removeToastSuccess, data });
